import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=4fabb651&"
import script from "./ShiftList.vue?vue&type=script&lang=js&"
export * from "./ShiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports